import CompanySummary from '~/components/organisms/CompanySummary'
import PrivacyPolicy from '~/components/organisms/PrivacyPolicy'

const AboutTemplate = () => {
  return (
    <>
      <div>
        <CompanySummary />
        <PrivacyPolicy />
      </div>
    </>
  )
}

export default AboutTemplate
